module.exports = __webpack_public_path__ + "images/assets/dacfce1976adb2f149d580c394da6a1a.svg";